import { mergeObjectTypes } from '../cacheHelpers';

const NetworksContact = {
  merge: mergeObjectTypes
};

export default NetworksContact;
